<template>
    <v-text-field        
        v-model="search"
        :label="searchLabel"
        hide-details
        clearable
        v-bind="$attrs"
        v-on="$listeners"
        :loading="isLoading"
        :alvqa="alvqa"
    >
        <template v-slot:append>
            <BaseTooltip v-if="iconTooltipText !== ''">
                <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                <template v-slot:text><span>{{ iconTooltipText }}</span></template>
            </BaseTooltip>
        </template>
    </v-text-field>
</template>

<script>
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "SearchFilter",
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        label: {
            type: String,
            default: '',
        },
        iconTooltipText: {
            type: String,
            default: ''
        },
        alvqa: {
            type: String,
            default: ''
        },
    },
    computed: {
        /** Returns the label of the text field for 'Search'.
         *  @return {String} Returns a string with the label in the selected language. */
        searchLabel() {
            if (this.label) {
                return this.$alvPlugin.isLangConst(this.label) ? this.$t(this.label) : this.label
            }
            return this.$t('lang_GENERIC_CAPTION_SEARCH')
        },

        /** Property with getter and setter for the object search in the store. */     
        search: {
            get() { return this.$store.getters['get' + this.context + 'Search'] },
            set(search) { this.$store.commit('set' + this.context + 'Search', search) }
        },
        isLoading: {
            get() { return this.$store.getters.getIsLoading },
            set(isLoading) { this.$store.commit('setIsLoading', isLoading)}
        }
    }
}
</script>